/**
 * geilstekerze First-Party-Tracking
 *
 * v1 (21.07.2026): session/init + Touchpoints (fbclid/gclid/UTM) + Event-Ingest
 * nach Cloudflare D1. Kein fbq()-Load hier -- das Meta-Pixel laeuft ueber das
 * bestehende Setup (GTM/Custom Pixel); ein zweiter Load gaebe doppelte PageViews.
 *
 * v2 (07.09.2026): unminifiziert zurueckgeschrieben, damit die Datei wieder
 * lesbar und pruefbar ist, plus zwei Ergaenzungen fuer die Burnie-Messung:
 *   - `window._gkSid()` gibt die Sitzungskennung heraus. Vorher lag sie in der
 *     Closure fest; ohne sie laesst sich der Weg Shop -> Beraterseite nicht als
 *     EIN Trichter messen.
 *   - der Burnie-Anbau am Ende zaehlt den Popup-Trichter und haengt die
 *     Sitzungskennung an die Links zur Beraterseite.
 *
 * Die Einwilligungsregel ist die STRENGE der Live-Fassung, nicht die des
 * Repos `geilstekerze-tracking`: ohne Shopifys Customer-Privacy-API wird NICHT
 * getrackt. Die Repo-Quelle stand am 07.09.2026 noch auf `return true` und ist
 * damit veraltet -- wer sie ausrollt, macht einen Datenschutz-Rueckschritt.
 */
(function () {
  'use strict';

  var PROXY = 'https://geilstekerze-proxy.geilstekerze.workers.dev';
  var API = 'https://geilstekerze-identity.geilstekerze.workers.dev';
  var sid = null;
  var anon = null;
  var started = false;

  function analyticsAllowed() {
    try {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      if (cp && typeof cp.analyticsProcessingAllowed === 'function') {
        return cp.analyticsProcessingAllowed() === true;
      }
    } catch (e) {}
    // Keine Customer-Privacy-API erreichbar -> im Zweifel NICHT tracken.
    return false;
  }

  function start() {
    if (started || !analyticsAllowed()) return;
    started = true;

    try { anon = localStorage.getItem('_gsk_anon'); } catch (e) {}
    var qs = new URLSearchParams(location.search);

    fetch(API + '/session/init', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        anonymous_id: anon,
        referrer: document.referrer,
        fbclid: qs.get('fbclid'),
        gclid: qs.get('gclid'),
        utm_source: qs.get('utm_source'),
        utm_medium: qs.get('utm_medium'),
        utm_campaign: qs.get('utm_campaign'),
        utm_content: qs.get('utm_content'),
        utm_term: qs.get('utm_term')
      })
    })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        sid = d.session_id;
        anon = d.anonymous_id;
        try { localStorage.setItem('_gsk_anon', anon); } catch (e) {}
        window._gk('track', 'PageView');
      })
      .catch(function () {});
  }

  window._gk = function (action, name, data) {
    try {
      if (!started) return;
      if (action === 'track') {
        fetch(PROXY + '/e', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            session_id: sid,
            event_type: name,
            page_url: location.href,
            value: data && data.value,
            product_id: data && data.content_ids && data.content_ids[0],
            order_id: data && data.order_id
          })
        }).catch(function () {});
      }
      if (action === 'identify' && data && (data.email || data.phone)) {
        fetch(API + '/identify', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            session_id: sid,
            email: data.email,
            phone: data.phone,
            first_name: data.first_name,
            last_name: data.last_name
          })
        }).catch(function () {});
      }
    } catch (e) {}
  };

  /** Die Sitzungskennung dieser Seite, oder null solange keine erteilt wurde. */
  window._gkSid = function () { return sid; };

  start();
  document.addEventListener('visitorConsentCollected', start);
})();

/**
 * Burnie-Spur (07.09.2026)
 *
 * Warum hier und nicht im Popup-Snippet: `snippets/burnie-embed.liquid` bleibt
 * dadurch Byte-identisch. Der Popup-Code ist am selben Tag live gegangen; ihn
 * fuer eine Messung erneut anzufassen waere das groessere Risiko. Dieser Anbau
 * haengt sich nur von aussen an vorhandene Kennungen und tut gar nichts, wenn
 * er sie nicht findet.
 *
 *  1. Zaehlt den Trichter im Shop: Einladung gesehen -> Knopf geklickt ->
 *     Ton eingeschaltet -> weggeklickt.
 *  2. Haengt die Sitzungskennung als `?gk=` an die Links zur Beraterseite.
 *     Erst dadurch ist der Weg Shop -> Burnie EIN Trichter statt zwei blinder
 *     Haelften.
 *
 * Einwilligung: `_gkSid()` liefert nur dann eine Kennung, wenn Shopify die
 * Analyse erlaubt hat. Ohne Einwilligung gibt es keine Kennung, also kein
 * `?gk=`, also misst auch die Beraterseite nichts. Die Kette haelt durchgehend
 * -- es gibt keinen zweiten Einwilligungsweg, der auseinanderlaufen koennte.
 */
(function () {
  'use strict';

  var BASIS = 'https://burnie-geilstekerze.vercel.app';
  var LINKS = 'a.burnie-knopf, a#burnie-los';
  var einladungGemeldet = false;

  function sitzung() {
    try { return (window._gkSid && window._gkSid()) || null; } catch (e) { return null; }
  }

  function melde(art) {
    try { if (window._gk) window._gk('track', art); } catch (e) {}
  }

  function mitSitzung(u) {
    var s = sitzung();
    return s ? u + (u.indexOf('?') < 0 ? '?' : '&') + 'gk=' + encodeURIComponent(s) : u;
  }

  /** Idempotent: baut den Link immer neu aus der Basis, nie aus dem Vorzustand. */
  function verlinken() {
    if (!sitzung()) return;
    var a = document.querySelectorAll(LINKS), i, ziel;
    for (i = 0; i < a.length; i++) {
      ziel = mitSitzung(BASIS);
      if (a[i].getAttribute('href') !== ziel) a[i].setAttribute('href', ziel);
    }
  }

  function passt(el, wahl) {
    return el && el.closest ? el.closest(wahl) : null;
  }

  // Aufnahmephase: laeuft vor der Navigation, damit der Link die
  // Sitzungskennung noch bekommt.
  document.addEventListener('click', function (e) {
    var z = e.target;
    if (passt(z, LINKS)) { verlinken(); melde('BurnieKnopf'); return; }
    if (passt(z, '#burnie-ton')) { melde('BurnieTon'); return; }
    if (passt(z, '#burnie-spaeter, #burnie-schliessen')) { melde('BurnieZu'); }
  }, true);

  // Die Einladung oeffnet erst nach zehn Sekunden Sichtzeit und setzt dabei
  // `data-offen="ja"`. Eine Uhr reicht und haelt den Anbau klein.
  var versuche = 0;
  var uhr = window.setInterval(function () {
    versuche++;
    verlinken();
    var karte = document.getElementById('burnie-einladung');
    if (!einladungGemeldet && karte && karte.getAttribute('data-offen') === 'ja') {
      einladungGemeldet = true;
      melde('BurnieEinladung');
    }
    // Nach zwei Minuten ist alles entschieden; laenger laufen waere Ballast.
    if (versuche > 240) window.clearInterval(uhr);
  }, 500);
})();
